import { Component } from '@angular/core';

@Component({
    selector: 'madero-policies',
    imports: [],
    templateUrl: './policies.component.html',
    styleUrl: './policies.component.scss'
})
export class PoliciesComponent {

}
